import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Input, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { callWithCatch } from '../utils';
import GroupsSelector2 from './GroupsSelector2';
import Spacer from './Spacer';
import TeamCard from './TeamCard';

const TeamsGroupsChooser = observer(({ teams: initialTeams, groups: initialGroups, onChange, addGroup }) => {
  const [teams, setTeams] = useState(initialTeams || []);
  const groups = initialGroups || [];

  // Get teams for a specific group
  const getTeamsForGroup = (groupId) => {
    return teams.filter(team => team.group_id === groupId);
  };

  // Get unassigned teams
  const getUnassignedTeams = () => {
    return teams.filter(team => !team.group_id);
  };

  // Handle team drop between groups
  const handleDrop = (group, team, index) => {
    const updatedTeams = teams.map(t => 
      t.id === team.id 
        ? { ...t, group_id: group?.id || null }
        : t
    );
    setTeams(updatedTeams);
    
    if (onChange) {
      onChange({
        teams: updatedTeams,
        groups
      });
    }
  };

  // Add new group
  const handleAddGroup = () => {
    if (addGroup) {
      addGroup();
    }
  };


  // Prepare groups data for GroupsSelector2
  const prepareGroupsData = () => {
    const groupsData = [
      {
        title: 'Unassigned',
        items: getUnassignedTeams(),
        id: null
      },
      ...groups.map(group => ({
        title: group.name,
        items: getTeamsForGroup(group.id),
        id: group.id
      }))
    ];

    return groupsData;
  };

  const groupsData = prepareGroupsData();

  return (
    <div>
      {addGroup && (
        <div className="mb-4">
          <Button 
            type="dashed" 
            onClick={handleAddGroup}
            icon={<PlusOutlined />}
          >
            Add New Group
          </Button>
        </div>
      )}

      <div className="overflow-x-auto">
        <GroupsSelector2
          groups={groupsData}
          onDrop={handleDrop}
          titleRender={g => (
            <Spacer>
              <div>{g.title} ({g.items.length})</div>
              {g.id && getUnassignedTeams().length > 0 && (
                <Button 
                  size="small" 
                  onClick={() => {
                    const updatedTeams = teams.map(team => 
                      !team.group_id ? { ...team, group_id: g.id } : team
                    );
                    setTeams(updatedTeams);
                    if (onChange) {
                      onChange({ teams: updatedTeams, groups });
                    }
                  }}
                >
                  Assign All
                </Button>
              )}
            </Spacer>
          )}
          itemRender={team => <TeamCard team={team} />}
        />
      </div>
    </div>
  );
});

export default TeamsGroupsChooser;